import { toast } from "react-toastify";
import api from "../services/api";
import ImportExportBar from "./ImportExportBar";

/**
 * Invoices without line items (data migrated from another system): one Excel row per bill with its total and the balance still
 * due. They are collected against like any other bill — payments page, mobile app, delivery.
 */
const HeaderOnlyInvoiceImport = () => {
  const downloadTemplate = async () => {
    try {
      await api.downloadFile("/api/v1/header-only-invoices/import/template", {}, "invoices-without-items-template.xlsx");
    } catch (error) {
      toast.error(error.message || "Could not download the template");
    }
  };

  return (
    <div className="p-4">
      <div className="filters-bar">
        <button type="button" className="secondary" onClick={downloadTemplate}>
          Download Template
        </button>
        <ImportExportBar importPath="/api/v1/header-only-invoices/import" label="Invoices Without Items" />
      </div>
      <div className="page-subtitle" style={{ marginTop: 10 }}>
        One row per bill. Columns: <b>Invoice Number</b>*, <b>Invoice Date</b>* (dd/mm/yyyy), <b>Invoice Amount</b>*, <b>Customer Code</b> or{" "}
        <b>Customer Name</b>* (a customer not found is created), Balance Amount (blank = the whole invoice amount), Due Date, Salesman Name,
        Beat Name, Load Sheet No. No discount, tax or stock is recorded for these bills; they appear on the payments page and the mobile
        app for collection. An invoice number already in the system is rejected.
      </div>
    </div>
  );
};

export default HeaderOnlyInvoiceImport;
